/**
 * Input formatting utilities for consistent data display and entry
 */

/**
 * Format phone number as XXX-XXX-XXXX (standardized format)
 * @param {string} value - Raw phone input
 * @returns {string} Formatted phone number
 */
export const formatPhoneNumber = (value) => {
  if (!value) return '';
  // Remove all non-digits
  const phoneNumber = value.replace(/\D/g, '');
  
  // Format as XXX-XXX-XXXX (backend compatible)
  if (phoneNumber.length <= 3) {
    return phoneNumber;
  } else if (phoneNumber.length <= 6) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  } else {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  }
};
